export const dividerVariants = {
  initial: {
    scaleX: 0,
  },
  animate: {
    scaleX: 1,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

export const variantsParent = {
  animate: {
    transition: {
      staggerChildren: 0.04,
      delayChildren: 0.2,
    },
  },
};

export const variantsText = {
  initial: {
    y: "100%",
    opacity: 0,
    rotateX: -90,
    transformOrigin: "top",
  },
  animate: {
    y: 0,
    rotateX: 0,
    opacity: 1,
    transition: { type: "spring", duration: 0.6 },
  },
};

export const variantsBlock = {
  initial: {
    y: 32,
    opacity: 0,
    transformOrigin: "top",
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", duration: 0.6 },
  },
};
